import { render, staticRenderFns } from "./contentLoading.vue?vue&type=template&id=ed4b168a&"
import script from "./contentLoading.vue?vue&type=script&lang=js&"
export * from "./contentLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports